<template>
  <v-card
    class="d-flex flex-grow-1"
    shaped
    :loading="prizes.status === contentStatus.loading"
  >
    <v-card-text class="d-flex flex-column justify-content-space-evenly">
      <div
        class="prize-item"
        v-for="prize in prizes.entries"
        :key="prize.identifier"
      >
        {{ prize.name }} - 1X :
        <span class="amount">{{ prize.amount }}</span>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "PrizesCard",
  inject: ["contentStatus"],
  props: {
    prizes: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss">
.prize-item {
	font-family: 'Intro', serif;
	font-size: 1.7rem;
	line-height: 1.7rem;
	border: solid red 2px;
	border-radius: 15px;
	padding: 10px;

	.amount {
		font-size: 1.9rem;
	}
}

.justify-content-space-evenly {
	justify-content: space-evenly;
}
</style>
